import { createLazyResource, createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { OwnersRepository } from '~/repositories/ownersRepository';
import type { OwnersFilter } from '~/repositories/ownersRepository';
import type { EstimateOwnerDistributionAchArrivalTimesDto, UpdateOwnerDto } from '~/swagger/portal/Api';

const repo = new OwnersRepository();
export const [OwnersProvider, useOwners] = createMagicDoorContext('Owners', () => {
  const [filtered, setFilter, actions] = createTriggerResource((filter: OwnersFilter) => repo.getOwners(filter));

  const [currentId, setCurrentId] = createSignal<string>();
  const [current, currentActions] = createLazyResource(currentId, (id) => repo.getOwner(id));

  const addOwner = async (payload: UpdateOwnerDto) => {
    const response = await repo.addOwner(payload);
    return response;
  };

  const updateOwner = async (id: string, payload: UpdateOwnerDto) => {
    const res = await repo.updateOwner(id, payload);
    currentActions.mutate(res);
  };

  const inviteOwner = createMutation(async (ownerId: string) => {
    const invite = await repo.portalInvite(ownerId);
    currentActions.refetch();
    return invite;
  });

  const changeOwnerPassword = createMutation(async (ownerId: string, password: string) => {
    await repo.changeOwnerPassword(ownerId, password);
    currentActions.refetch();
  });

  const deactivateOwner = createMutation(async (ownerId: string) => {
    await repo.deactivateOwner(ownerId);
    actions.refetch();
  });

  const estimateOwnerDistributionAchArrivalTimes = createMutation(async (payload: EstimateOwnerDistributionAchArrivalTimesDto) => {
    const result = await repo.estimateOwnerDistributionAchArrivalTimes(payload);
    return result;
  });

  return {
    filtered: filtered,
    setFilter: (filter: OwnersFilter) => setFilter(filter),
    current,
    setCurrentId,
    refetch: actions.refetch,
    addOwner,
    updateOwner,
    inviteOwner,
    changeOwnerPassword,
    currentActions,
    deactivateOwner,
    estimateOwnerDistributionAchArrivalTimes,
  };
});
